/* unplugin-vue-components disabled */import script from "./LoopSwipe.vue?vue&type=script&setup=true&lang=js"
export * from "./LoopSwipe.vue?vue&type=script&setup=true&lang=js"

import "./LoopSwipe.vue?vue&type=style&index=0&id=ea82de26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea82de26"]])

export default __exports__